export default "__VITE_ASSET__Ce8otGn9__"